export const BOOKING_URL =
  'https://calendly.com/dan-at-turnout/turnout-general-30-min-call'
export const CONTACT_EMAIL = 'dan@turnout.info'
export const LINKEDIN_URL = '[LINKEDIN URL]'

export const assets = {
  turnoutLogo:
    'https://cdn.magicpatterns.com/uploads/mGJzFe33DXdGGbrUZqM2ty/app-logo.png',
  dan:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/puQfL52NJjm2xZfDkLctHA/1744810493288_%281%29.jpg',
} as const

export const clientLogos = [
  {
    name: 'NuCo Wallet',
    src: 'https://cdn.magicpatterns.com/uploads/2Howrn1KdZfeMi6Skg6vKy/logo--nuco-wallet-logo.svg',
    darkBackground: false,
  },
  {
    name: 'Avtal',
    src: 'https://cdn.magicpatterns.com/uploads/n6qxVuaq3CxJ5cKSHGkwDm/logo--avtal-logo.svg',
    darkBackground: false,
  },
  {
    name: 'Systalent USA',
    src: 'https://cdn.magicpatterns.com/uploads/a2aevZjxa7Q5Y1fE2xwdRN/logo--systalent-logo-color.png',
    darkBackground: false,
  },
  {
    name: 'Vectyr',
    src: 'https://cdn.magicpatterns.com/uploads/sm1b6bPhaKzJgHnCHu6iCc/logo--vectyr-logo.svg',
    darkBackground: true,
  },
  {
    name: 'TekRevol',
    src: 'https://cdn.magicpatterns.com/uploads/5SMzxVZ47QDuNK7Pbf7y9w/logo--tekrevol-logo-black.svg',
    darkBackground: false,
  },
] as const

export const problemCards = [
  'Most exhibitors arrive with a booth, a badge scanner, and no qualified meetings on the calendar.',
  'Attendee lists are noisy. Reps lose days finding the few people who actually fit your ICP.',
  'Once the show starts, your team is too busy working the floor to prospect well.',
] as const

export const howItWorks = [
  {
    title: 'Tell us the show and ICP',
    description:
      'We align on the conference, target accounts, buyer roles, offer, and meeting goal.',
  },
  {
    title: 'We build the attendee list',
    description:
      'We source likely attendees and exhibitors, then rank the people most worth your reps’ time.',
  },
  {
    title: 'We run pre-show outbound',
    description:
      'We write and send personalized outreach, manage replies, and qualify interest.',
  },
  {
    title: 'Meetings hit the calendar',
    description:
      'Qualified prospects book directly onto your reps’ calendars before the show opens.',
  },
] as const

export const conferenceSupport = [
  'Attendee sourcing',
  'ICP matching',
  'Personalized outreach',
  'Reply qualification',
  'Calendar scheduling',
] as const

export const benchmarks = [
  { value: '1,000', text: 'target attendees in a typical campaign universe' },
  { value: '~310', text: 'connections from a focused pre-show campaign' },
  { value: '22', text: 'qualified leads created from that outreach' },
  { value: 'Day 1', text: 'your reps arrive with meetings already scheduled' },
] as const

export const conferenceCampaigns = clientLogos.map((logo, index) => {
  const campaigns = [
    {
      conference: 'Fintech conference',
      audience: 'Partnership, product, and payments leaders',
    },
    {
      conference: 'Talent and HR conference',
      audience: 'People, recruiting, and engineering leaders',
    },
    {
      conference: 'Technology conference',
      audience: 'Talent acquisition and delivery leaders',
    },
    {
      conference: 'Brand and retail conference',
      audience: 'Brand, CX, and partnership leaders',
    },
    {
      conference: 'Healthcare technology conference',
      audience: 'Operators and technology leaders',
    },
  ] as const

  return { ...logo, ...campaigns[index] }
})

export const faqItems = [
  {
    question: 'How far before the conference should we start?',
    answer:
      'Four to six weeks is ideal. We can run a shorter sprint when the attendee signal is strong.',
  },
  {
    question: 'Do we need the official attendee list?',
    answer:
      'No. We combine public signals, exhibitor data, target-account research, and your own lists.',
  },
  {
    question: 'Who sends the outreach?',
    answer:
      'We run the campaign with messaging approved by your team and make the handoff when a prospect is qualified.',
  },
  {
    question: 'Where do meetings get booked?',
    answer:
      'Directly onto the calendars you choose, with the context your reps need for the conversation.',
  },
  {
    question: 'Can you support multiple reps or territories?',
    answer:
      'Yes. We route meetings by account, territory, role, availability, or any rules your team sets.',
  },
  {
    question: 'How do you report results?',
    answer:
      'You see the target universe, outreach, replies, qualified conversations, and meetings booked for each show.',
  },
] as const
